import logo from './logo.svg';
import './App.css';
import HeroSection from './Components/HeroSection';
import ScrollSection from './Components/FeatureScrollSection';
import ExtendExperience from './Components/ExtendExperience';

function App() {
  return (
    <>
    <HeroSection/>
    <ScrollSection/>
    <ExtendExperience/>
    </>
    
  );
}

export default App;
